import axios from "axios";  
import { Payout_Service } from "../Url";

export const payoutApprovalStagesAction = {
  PAYOUT_APPROVAL_STAGES_SUCCESS: "PAYOUT_APPROVAL_STAGES_SUCCESS",
  PAYOUT_APPROVAL_STAGES_ERROR: "PAYOUT_APPROVAL_STAGES_ERROR",
  PARTNER_APPROVAL_STAGES_SUCCESS: "PARTNER_APPROVAL_STAGES_SUCCESS",
  PARTNER_APPROVAL_STAGES_ERROR: "PARTNER_APPROVAL_STAGES_ERROR",
};




export function payoutApprovalStagesSuccess(props) {
  const { accessToken,reportId} = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/get/approvalStagesWithPartnerCount?report_id=${reportId}`,
        // url: `http://localhost:8301/partner-payout-service/reports/get/approvalStagesWithPartnerCount?report_id=${reportId}`,
      });
      const data = response.data;
      dispatch({
        type: payoutApprovalStagesAction.PAYOUT_APPROVAL_STAGES_SUCCESS,
        payload: data.data,
      });
      console.log("Payout Approval Stages:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: payoutApprovalStagesAction.PAYOUT_APPROVAL_STAGES_ERROR,
        payload: error.message || "Failed to fetch payout approval stages",
      });
      return error;
    }
  };
}


export function partnerApprovalStagesSuccess(props) {
  const { accessToken,approvalStageId, monthlyReportId, partnerId, approveData } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/approve-parnter?approval_stage_id=${approvalStageId}&monthly_report_id=${monthlyReportId}&partner_id=${partnerId}`,
        // url: `http://localhost:8301/partner-payout-service/reports/approve-parnter?approval_stage_id=${approvalStageId}&monthly_report_id=${monthlyReportId}&partner_id=${partnerId}`,
        data: approveData,
      });
      const data = response.data;
      dispatch({
        type: payoutApprovalStagesAction.PARTNER_APPROVAL_STAGES_SUCCESS,
        payload: data.data,
      });
      console.log("Partner Approval Stages:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: payoutApprovalStagesAction.PARTNER_APPROVAL_STAGES_ERROR,
        payload: error.message || "Failed to fetch partner approval stages",
      });
      return error;
    }
  };
}
